import { Skeleton, Stack } from "@mui/material";
import { type FC } from "react";

import * as Styled from "./MarketsTabs.styles";

const TAB_HEIGHT = 32;
const FILTER_HEIGHT = 32;
const FILTER_WIDTHS = [96, 108, 88, 96, 92, 84, 100];
const GRID_HEIGHT = 320;

export const MarketsTabsSkeleton: FC = () => {
  return (
    <Styled.Root>
      <Stack
        direction="row"
        sx={{
          gap: 3,
          pb: 1,
          borderBottom: 1,
          borderColor: "divider"
        }}>
        <Skeleton variant="text" width={72} height={TAB_HEIGHT} />
        <Skeleton variant="text" width={64} height={TAB_HEIGHT} />
      </Stack>

      <Stack
        direction="row"
        sx={{
          flexWrap: "wrap",
          gap: 1,
          mb: 1,
          py: { xs: 1, md: 1.5 }
        }}>
        {FILTER_WIDTHS.map((width, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width={width}
            height={FILTER_HEIGHT}
            sx={index > 0 ? { display: { xs: "none", md: "block" } } : undefined}
          />
        ))}
      </Stack>

      <Skeleton variant="rounded" width="100%" height={GRID_HEIGHT} />
    </Styled.Root>
  );
};
